__turbopack_context__.v({
  "button": "Button-module__BFIuKa__button",
  "danger": "Button-module__BFIuKa__danger",
  "fullWidth": "Button-module__BFIuKa__fullWidth",
  "ghost": "Button-module__BFIuKa__ghost",
  "lg": "Button-module__BFIuKa__lg",
  "loading": "Button-module__BFIuKa__loading",
  "md": "Button-module__BFIuKa__md",
  "primary": "Button-module__BFIuKa__primary",
  "secondary": "Button-module__BFIuKa__secondary",
  "sm": "Button-module__BFIuKa__sm",
});
